export const BaseAPIUrl = '{BaseAPIUrl}';

export const CartId = '{CartId}';
export const EntryId = '{EntryId}';
export const SubCartId = '{SubCartId}';
export const ListId = '{ListId}';

export const API_Version_CART = 'v2'; // change to v2 for cart and keep v1 for list
export const API_Version_LIST = 'v1';
